


// import React, { Component } from 'react';
// import {
//     Button,
//     Stack,
//     TextField,
//     Paper,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     TablePagination,
//     Autocomplete,
//     IconButton,
//     Tooltip,
//     Box,
//     InputAdornment
// } from '@mui/material';
// import '../Configurations/Configuration.css';
// import { Colors } from '../../Styles/Colors';
// import { ImagePaths } from '../../Utility/ImagePaths';
// import { withTranslation } from 'react-i18next';
// import { DeletePopup } from '../../Components/Common Components/CommonComponents';
// import { AmountFormat, CheckAccessFunc } from '../../Components/CommonFunctions/CommonFunctions';
// import SearchIcon from '@mui/icons-material/Search';
// import ToastMsg from '../../Components/ToastMsg/ToastMsg';
// import RestAPIService from '../../Utility/Services/RestAPIService';
// import { Serviceurls } from '../../Utility/API/Serviceurls';
// import Loader from '../../Components/Loader'
// import CommonValidation from '../../Components/CommonFunctions/CommonValidation';
// import { CurrencySymbol } from '../../Utility/Constants';

// class OutsourceMapping extends Component {
//     constructor(props) {
//         super(props)
//         this.state = {
//             page: 0,
//             rowsPerPage: 10,
//             selectOutLabName: null,
//             selectOutLabName1: '',
//             outsourceTestPrice: '',
//             outsourceMappingData: [],
//             isErrorMsg: false,
//             isErrorMsgText: '',
//             successMsg: false,
//             successMsgText: '',
//             testNameTableValue: [],
//             testNameGet: [],
//             testOutSourceLabGet: [],
//             deletedID: [],
//             deletedPopup: false,
//             deletedapiID: '',
//             searchKey: '',
//             selectedIndex: '',
//             SearchText: "",
//             disableBtn: false,
//             isLoader: false,
//             selectedEditID: null,
//             // State for hierarchical structure
//             selectedHeadService: null,
//             selectedServiceName: null,
//             serviceDetails: []
//         }
//     }

//     componentDidMount() {
//         this.getTestNameData()
//         this.getOutSourceLabData()
//         this.getOutsourceMappingData()
//     }

//     msgClose() {
//         this.setState({
//             isErrorMsg: false,
//             isErrorMsgText: '',
//             successMsg: false,
//             successMsgText: '',
//         })
//     }

//     getTestNameData = () => {
//         try {
//             // Pass module_type as parameter for HISTOPATHOLOGY
//             RestAPIService.getAll(`${Serviceurls.MODULE_LIST}?module_type=HISTOPATHOLOGY`)
//                 .then(response => {
//                     if (response.data.status === "success") {
//                         const moduleData = response.data.data || {};
                        
//                         // Extract service heads from HISTOPATHOLOGY module
//                         const histopathologyData = moduleData.HISTOPATHOLOGY || [];
                        
//                         this.setState({
//                             testNameGet: histopathologyData
//                         })
//                     }
//                 }).catch(e => {
//                     this.setState({
//                         isErrorMsg: true,
//                         isErrorMsgText: e.message
//                     })
//                 })

//         } catch (e) {
//             this.setState({
//                 isErrorMsg: true,
//                 isErrorMsgText: e.message
//             })
//         }
//     }

//     getOutSourceLabData = () => {
//         try {
//             RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_OUTSOURCE_CONFIG)
//                 .then(response => {
//                     if (response.data.status === "success") {
//                         this.setState({
//                             testOutSourceLabGet: response.data.data ? response.data.data : []
//                         })
//                     }
//                 }).catch(e => {
//                     this.setState({
//                         isErrorMsg: true,
//                         isErrorMsgText: e.message
//                     })
//                 })

//         } catch (e) {
//             this.setState({
//                 isErrorMsg: true,
//                 isErrorMsgText: e.message
//             })
//         }
//     }

//     LoaderFunction = (key) => {
//         this.setState({
//             isLoader: key
//         })
//     }

//     getOutsourceMappingData = () => {
//         try {
//             this.LoaderFunction(true)
//             RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_OUTSOURCE_MAPPING + "?search_key=" + this.state.searchKey)
//                 .then(response => {
//                     if (response.data.status === "success") {
//                         this.setState({
//                             outsourceMappingData: response.data.data ? response.data.data : []
//                         }, () => { this.LoaderFunction(false) })
//                     }
//                 }).catch(e => {
//                     this.LoaderFunction(false)
//                     this.setState({
//                         isErrorMsg: true,
//                         isErrorMsgText: e.message
//                     })
//                 })

//         } catch (e) {
//             this.LoaderFunction(false)
//             this.setState({
//                 isErrorMsg: true,
//                 isErrorMsgText: e.message
//             })
//         }
//     }

//     postOutsourceMappingData = () => {
//         try {
//             this.LoaderFunction(true)
//             var states = this.state
//             var outsourceLabID = states.selectOutLabName ? states.selectOutLabName.id : null
//             var outsourceLabName = states.selectOutLabName ? states.selectOutLabName.outsource_laboratory_name : null
            
//             // Prepare outsource_line_item according to API structure
//             const outsourceLineItem = states.testNameTableValue.map(item => ({
//                 service_head_id: item.service_head_id || null,
//                 service_head_str: item.service_head_str || null,
//                 service_name_id: item.service_name_id || null,
//                 service_name_str: item.service_name_str || null,
//                 amount: item.amount || null
//             }))

//             var data = {
//                 "outsource_id": outsourceLabID,
//                 "outsource_laboratory_name": outsourceLabName,
//                 "outsource_line_item": outsourceLineItem
//             }

//             if (this.state.selectedEditID) {
//                 data['outsource_id'] = this.state.selectedEditID
//                 data['deleted_ids'] = this.state.deletedID
//             }

//             this.setState({ disableBtn: true })
//             RestAPIService.create(data, Serviceurls.HISTOPATHOLOGY_OUTSOURCE_MAPPING)
//                 .then(response => {
//                     if (response.data.status == "success") {
//                         this.setState({
//                             successMsg: true,
//                             successMsgText: response.data.message
//                         }, () => {
//                             this.LoaderFunction(false)
//                             this.getOutsourceMappingData()
//                             this.setState({
//                                 selectOutLabName1: '',
//                                 testNameTableValue: [],
//                                 selectedEditID: '',
//                                 disableBtn: false,
//                                 selectedHeadService: null,
//                                 selectedServiceName: null,
//                                 serviceDetails: [],
//                                 outsourceTestPrice: ''
//                             })
//                         })
//                     }
//                 }).catch(e => {
//                     this.LoaderFunction(false)
//                     this.setState({
//                         isErrorMsg: true,
//                         isErrorMsgText: e.response?.data?.message || e.message,
//                         disableBtn: false,
//                     })
//                 })
//         } catch (e) {
//             this.LoaderFunction(false)
//             this.setState({
//                 isErrorMsg: true,
//                 isErrorMsgText: e.message,
//                 disableBtn: false,
//             })
//         }
//     }

//     editOutsourceMappingData = (item, index) => {
//         this.setState({
//             selectedEditID: item.out_source_id,
//             selectOutLabName1: item.out_source__outsource_laboratory_name ? item.out_source__outsource_laboratory_name : '',
//             testNameTableValue: item.data,
//             selectedIndex: index,
//         })
//     }

//     deleteOutsourceMappingData = (ID) => {
//         try {
//             var data = {
//                 "outsource_id": ID
//             }
//             RestAPIService.delete(Serviceurls.HISTOPATHOLOGY_OUTSOURCE_MAPPING, data)
//                 .then(response => {
//                     if (response.data.status == "success") {
//                         this.setState({
//                             successMsg: true,
//                             successMsgText: response.data.message
//                         }, () => {
//                             this.getOutsourceMappingData()
//                         })
//                     }
//                 }).catch((e => {
//                     this.setState({
//                         isErrorMsg: true,
//                         isErrorMsgText: e.response?.data?.message || e.message
//                     })
//                 }))

//         } catch (e) {
//             this.setState({
//                 isErrorMsg: true,
//                 isErrorMsgText: e.message
//             })
//         }
//     }

//     handleChangePage = (event, newPage) => {
//         this.setState({ page: newPage });
//     }

//     handleChangeRowsPerPage = (event) => {
//         this.setState({ rowsPerPage: +event.target.value, page: 0 });
//     }

//     numInputcheck = (event) => {
//         const name = event.target.name;
//         const value = event.target.value;
//         if (value === "" || CommonValidation.NumberWithDot(value) && value > 0) {
//             this.setState({
//                 [name]: value,
//             });
//         }
//     };

//     renderTextBox = (label, width, value, name) => {
//         return (
//             <div>
//                 <TextField
//                     size={'small'}
//                     sx={{ width: width }}
//                     label={label}
//                     rows={3}
//                     name={name}
//                     value={value}
//                     variant="outlined"
//                     onChange={this.numInputcheck}
//                 />
//             </div>
//         )
//     }

//     renderLeftTable = () => {
//         var states = this.state
//         const { t } = this.props
//         const filtereddata = this.state.outsourceMappingData.filter((data) => {
//             return (
//                 (data.out_source__outsource_laboratory_name === null ? null : data.out_source__outsource_laboratory_name.toLowerCase().includes(this.state.SearchText.toLowerCase())) ||
//                 (data.data === null ? null : JSON.stringify(data.data).toLowerCase().includes(this.state.SearchText.toLowerCase()))
//             );
//         });
//         return (
//             <div>
//                 <Paper elevation={0}>
//                     <Box className="eMed_Search_Box_">
//                         <TextField
//                             variant='standard'
//                             placeholder='Search'
//                             value={this.state.SearchText}
//                             onChange={(e) => { this.setState({ SearchText: e.target.value }) }}
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <SearchIcon />
//                                     </InputAdornment>
//                                 ),
//                             }}
//                             sx={{ width: '15vw' }} />
//                     </Box>
//                     <TableContainer className='eMed_ConfigTable_Paper'>
//                         <Table stickyHeader size='small'>
//                             <TableHead sx={{ height: '7.3vh' }}>
//                                 <TableRow>
//                                     <TableCell id='eMed_config_TableRow1' align='left' sx={{ color: Colors.HeadText }} >{t('SNo')}</TableCell>
//                                     <TableCell id='eMed_config_TableRow' align='left' sx={{ color: Colors.HeadText }}>{t("LaboratoryName")}</TableCell>
//                                     <TableCell id='eMed_config_TableRow' align='left' sx={{ color: Colors.HeadText }}>{t('TestName/Group')}</TableCell>
//                                     <TableCell id='eMed_config_TableRow' align='center' sx={{ color: Colors.HeadText }}>{t('Action')}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             {filtereddata.slice(states.page * states.rowsPerPage, states.page * states.rowsPerPage + states.rowsPerPage)
//                                 .map((data, index) => {
//                                     var sno = (states.page * states.rowsPerPage) + (index + 1)
//                                     var testGroup = []
//                                     const Datas = data.data
//                                     Datas.forEach(element => {
//                                         const displayName = element.service_name_str || element.service_head_str || '-';
//                                         testGroup.push(displayName);
//                                     });
//                                     return (
//                                         <TableBody key={index}>
//                                             <TableRow sx={{ bgcolor: this.state.selectedEditID && this.state.selectedIndex == index ? '#e2e2e2' : 'white' }}>
//                                                 <TableCell align='left'><div>{sno}</div></TableCell>
//                                                 <TableCell align='left'>
//                                                     {data.out_source__outsource_laboratory_name && data.out_source__outsource_laboratory_name.length > 15 ?
//                                                         <Tooltip placement="top" title={data.out_source__outsource_laboratory_name} arrow>
//                                                             <div >{data.out_source__outsource_laboratory_name ? data.out_source__outsource_laboratory_name.slice(0, 15) + '...' : '-'}</div>
//                                                         </Tooltip> : <div> {data.out_source__outsource_laboratory_name ? data.out_source__outsource_laboratory_name : '-'}</div>}</TableCell>
//                                                 <TableCell align='left'>
//                                                     {testGroup.length > 1 ?
//                                                         <Tooltip placement="top" title={<span><p>{testGroup ? testGroup.join(', ') : '-'}</p></span>} arrow>
//                                                             <div >{testGroup ? testGroup.slice(0, 2).join(', ') + '...' : '-'}</div>
//                                                         </Tooltip> : <div> {testGroup.join(', ')}</div>}</TableCell>
//                                                 <TableCell align='center'>
//                                                     <div className='eMed_TestConfig_Con'>
//                                                         <IconButton size='small' disabled={!CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess}>
//                                                             <img src={CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess ? ImagePaths.Edit?.default || ImagePaths.Edit : ImagePaths.DisabledEdit?.default || ImagePaths.DisabledEdit} className='eMed_TestConfig_DeleteIcon' alt='Edit'
//                                                                 onClick={() => { this.editOutsourceMappingData(data, index) }}
//                                                             />
//                                                         </IconButton>
//                                                         <IconButton size='small' disabled={!CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess}>
//                                                             <img src={CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess ? ImagePaths.Delete?.default || ImagePaths.Delete : ImagePaths.DisabledDelete?.default || ImagePaths.DisabledDelete} className='eMed_TestConfig_DeleteIcon' alt='Delete'
//                                                                 onClick={() => {
//                                                                     this.setState({
//                                                                         deletedPopup: true,
//                                                                         deletedapiID: data.out_source_id
//                                                                     })
//                                                                 }}
//                                                             />
//                                                         </IconButton>
//                                                     </div>
//                                                 </TableCell>
//                                             </TableRow>
//                                         </TableBody>
//                                     )
//                                 })
//                             }
//                         </Table>
//                         {filtereddata.length === 0 ?
//                             <div className='eMed_TestConfig_NoRecords'>
//                                 {t('NoRecordsShown')}
//                             </div> : null}
//                     </TableContainer>
//                 </Paper>
//                 <div className='eMed_TestConfig_LeftPageination'>
//                     <TablePagination
//                         component='div'
//                         id="eMed_tbl_pagination"
//                         rowsPerPageOptions={[10, 20, 30]}
//                         count={filtereddata.length}
//                         rowsPerPage={states.rowsPerPage}
//                         page={states.page}
//                         onPageChange={this.handleChangePage}
//                         onRowsPerPageChange={this.handleChangeRowsPerPage}
//                     />
//                 </div>
//             </div>
//         )
//     }

//     renderRightTable = () => {
//         var { testNameTableValue } = this.state
//         const { t } = this.props
//         return (
//             <div>
//                 <Paper elevation={0}>
//                     <TableContainer className='eMed_ConfigRightTable_Paper'>
//                         <Table stickyHeader size='small'>
//                             <TableHead sx={{ flex: 1, }}>
//                                 <TableRow>
//                                     <TableCell id='eMed_config_TableRow1' align='left'>{t('SNo')}</TableCell>
//                                     <TableCell id='eMed_config_TableRow' align='left'>{t('Test/Group')}</TableCell>
//                                     <TableCell id='eMed_config_TableRow' align='left'>{t('Price') + ` (${CurrencySymbol})`}</TableCell>
//                                     <TableCell id='eMed_config_TableRow' align='center'>{t('Action')}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             {testNameTableValue && testNameTableValue.length > 0 ? testNameTableValue.map((item, index) => {
//                                 const displayName = item.service_name_str || item.service_head_str || item.lab_test_name || item.lab_set_name || '-';
//                                 return (
//                                     <TableBody key={index}>
//                                         <TableRow>
//                                             <TableCell align='left'><div>{index + 1}</div></TableCell>
//                                             <TableCell align='left'>{displayName}</TableCell>
//                                             <TableCell align='left'>{item.amount ? AmountFormat(item.amount)?.replace(`${CurrencySymbol}`, "") : '0.00'}</TableCell>
//                                             <TableCell align='center'>
//                                                 <Tooltip title='Delete' placement='top' arrow>
//                                                     <img className='eMed_TestConfig_DeleteIcon' style={{ cursor: 'pointer' }} src={ImagePaths.Delete?.default || ImagePaths.Delete} alt="Delete"
//                                                         onClick={() => {
//                                                             var deletedID = []
//                                                             if (item.id) {
//                                                                 deletedID.push(item.id)
//                                                             }
//                                                             testNameTableValue.splice(index, 1)
//                                                             this.setState({
//                                                                 testNameTableValue,
//                                                                 deletedID: deletedID
//                                                             })
//                                                         }}
//                                                     />
//                                                 </Tooltip>
//                                             </TableCell>
//                                         </TableRow>
//                                     </TableBody>
//                                 )
//                             }) : null}
//                         </Table>
//                         {testNameTableValue.length === 0 ?
//                             <div className='eMed_TestConfig_NoRecords'>
//                                 {t("NoRecordsFound")}
//                             </div> : null}
//                     </TableContainer>
//                 </Paper>
//             </div>
//         )
//     }

//     clearValue = () => {
//         this.setState({
//             selectOutLabName1: null,
//             outsourceTestPrice: '',
//             testNameTableValue: [],
//             selectedIndex: '',
//             selectedEditID: '',
//             selectedHeadService: null,
//             selectedServiceName: null,
//             serviceDetails: []
//         })
//     }

//     validCheck = () => {
//         const { t } = this.props
//         var saveErrorMsg = ''
//         var states = this.state
//         if (!states.selectOutLabName1) {
//             saveErrorMsg = t('AddOutSourceLab')
//         } else if ((states.testNameTableValue).length == 0) {
//             saveErrorMsg = t('AddTest')
//         }
//         return saveErrorMsg
//     }

//     onSave = () => {
//         var inValid = this.validCheck()
//         if (inValid) {
//             this.setState({
//                 isErrorMsg: true,
//                 isErrorMsgText: inValid
//             })
//         } else {
//             this.postOutsourceMappingData()
//         }
//     }

//     addTestName = () => {
//         var states = this.state
//         const { t } = this.props
        
//         // Validation checks
//         if (!states.selectedHeadService && !states.selectedServiceName) {
//             this.setState({
//                 isErrorMsg: true,
//                 isErrorMsgText: t('SelectServiceHeadOrServiceName')
//             })
//             return
//         }

//         if (!states.outsourceTestPrice || states.outsourceTestPrice === '' || states.outsourceTestPrice === '0') {
//             this.setState({
//                 isErrorMsg: true,
//                 isErrorMsgText: t('EnterValidOutsourceAmt')
//             })
//             return
//         }

//         // Prepare data according to API structure
//         const newItem = {
//             service_head_id: states.selectedHeadService ? states.selectedHeadService.id : null,
//             service_head_str: states.selectedHeadService ? states.selectedHeadService.head_name : null,
//             service_name_id: states.selectedServiceName ? states.selectedServiceName.id : null,
//             service_name_str: states.selectedServiceName ? (states.selectedServiceName.service_name || states.selectedServiceName.name) : null,
//             amount: states.outsourceTestPrice
//         }

//         // Add to table
//         states.testNameTableValue.push(newItem)
        
//         this.setState({
//             testNameTableValue: states.testNameTableValue,
//             selectedServiceName: null,
//             selectedHeadService: null,
//             serviceDetails: [],
//             outsourceTestPrice: ''
//         })
//     }

//     PopupClose = () => {
//         this.setState({
//             deletedPopup: false
//         })
//     }

//     removeDataList = () => {
//         this.deleteOutsourceMappingData(this.state.deletedapiID)
//         this.setState({
//             deletedPopup: false
//         })
//     }

//     render() {
//         const { t } = this.props
//         var states = this.state

//         return (
//             <div className='eMed_TestConfig_MainContainer'>
//                 <div className='eMed_TestConfig_Con'>
//                     <div className='eMed_TestConfig_leftSide'>
//                         {this.renderLeftTable()}
//                     </div>
//                     <div className='eMed_TestConfig_RightSide'>
//                         <div className='eMed_TestConfig_RightHead'>
//                             <p className='eMed_Testconfig_RightHead_text'>{t('OutsourceMapping')}</p>
//                         </div>
//                         <div className='eMed_TestConfig_RightContentBox'>
//                             {/* Outsource Laboratory Name */}
//                             <div className='eMed_TestConfig_RightMethod'>
//                                 <Autocomplete
//                                     disabled={this.state.selectedEditID && this.state.selectedEditID ? true : false}
//                                     options={states.testOutSourceLabGet || []}
//                                     getOptionLabel={(options) => typeof (options) === "string" ? options : options.outsource_laboratory_name || ''}
//                                     onChange={(e, value) => {
//                                         this.setState({
//                                             selectOutLabName1: value,
//                                             selectOutLabName: value,
//                                         })
//                                     }}
//                                     value={states.selectOutLabName1 ? states.selectOutLabName1 : null}
//                                     id="combo-box-demo"
//                                     sx={{ width: "29vw" }}
//                                     renderInput={(params) => <TextField {...params} label={t("OutsourceLaboratoryName") + "*"} size='small' />}
//                                 />
//                             </div>
                            
//                             {/* Service Head and Service Name - Hierarchical Structure */}
//                             <div className='eMed_TestConfig_RightMethod'>
//                                 <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: '1vw' }}>
//                                     {/* Service Head */}
//                                     <Autocomplete
//                                         clearIcon
//                                         size='small'
//                                         sx={{ width: "14vw" }}
//                                         options={states.testNameGet || []}
//                                         getOptionLabel={(option) => option?.head_name || ''}
//                                         value={states.selectedHeadService || null}
//                                         onChange={(e, value) => {
//                                             this.setState({
//                                                 selectedHeadService: value,
//                                                 selectedServiceName: null,
//                                                 serviceDetails: value?.service_details || []
//                                             })
//                                         }}
//                                         renderInput={(params) => <TextField {...params} label={t("Service Head")} size='small' />}
//                                     />
                                    
//                                     {/* Service Name */}
//                                     <Autocomplete
//                                         clearIcon
//                                         size='small'
//                                         sx={{ width: "14vw" }}
//                                         options={states.serviceDetails || []}
//                                         getOptionLabel={(option) => option?.service_name || option?.name || ''}
//                                         value={states.selectedServiceName}
//                                         onChange={(e, value) => {
//                                             this.setState({
//                                                 selectedServiceName: value
//                                             })
//                                         }}
//                                         renderInput={(params) => <TextField {...params} label={t("Service Name")} size='small' />}
//                                     />
//                                 </Box>
//                             </div>

//                             {/* Outsource Amount and Add Button */}
//                             <div className='eMed_TestConfig_RightMethod'>
//                                 {this.renderTextBox(t("OutsourceAmount") + "*", '14vw', states.outsourceTestPrice, 'outsourceTestPrice')}
//                                 <Button id='eMed_Btn_Text' variant='contained' sx={{ width: '5vw' }}
//                                     onClick={() => { this.addTestName() }}
//                                 >{t('Add')}</Button>
//                             </div>
                            
//                             {/* Right Side Table */}
//                             <div className='eMed_TestConfig_Right_SideTable'>
//                                 {this.renderRightTable()}
//                             </div>
//                         </div>
//                         <div className='eMed_TestConfig_RightBtnCon'>
//                             <Stack spacing={2} direction="row">
//                                 <Button id='eMed_Btn_Text' variant='outlined' onClick={() => { this.clearValue() }}>{t("Clear")}</Button>
//                                 <Button id='eMed_Btn_Text' emed_tid='OutsourceMap_Save_Btn' disabled={this.state.disableBtn ? true : !CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess} variant='contained' onClick={() => { this.onSave() }}>{t("Save")}</Button>
//                             </Stack>
//                         </div>
//                     </div>
//                 </div>
//                 {this.state.isErrorMsg ?
//                     <ToastMsg
//                         severity={'error'}
//                         msg={this.state.isErrorMsgText}
//                         msgPop={this.msgClose.bind(this)}
//                     />
//                     : null}
//                 {this.state.successMsg ?
//                     <ToastMsg
//                         severity={'success'}
//                         msg={this.state.successMsgText}
//                         msgPop={this.msgClose.bind(this)}
//                     />
//                     : null}
//                 {this.state.deletedPopup ?
//                     <DeletePopup DeletTitle={t("ConfirmremoveOutsourceMap")}
//                         DeleteNotify={t("effectEntireConfig")}
//                         DeletContent={t("linkedOutsourceMap")}
//                         deleteAlertPopupClose={this.PopupClose.bind(this)}
//                         removeData={this.removeDataList.bind(this)}
//                     />
//                     : null}
//                 <Loader loaderOpen={this.state.isLoader} />
//             </div>
//         );
//     }
// }

// export default withTranslation()(OutsourceMapping);



import React, { Component } from 'react';
import {
    Button,
    Stack,
    TextField,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Autocomplete,
    IconButton,
    Tooltip,
    Box,
    InputAdornment
} from '@mui/material';
import '../Configurations/Configuration.css';
import { Colors } from '../../Styles/Colors';
import { ImagePaths } from '../../Utility/ImagePaths';
import { withTranslation } from 'react-i18next';
import { DeletePopup } from '../../Components/Common Components/CommonComponents';
import { AmountFormat, CheckAccessFunc } from '../../Components/CommonFunctions/CommonFunctions';
import SearchIcon from '@mui/icons-material/Search';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import Loader from '../../Components/Loader'
import CommonValidation from '../../Components/CommonFunctions/CommonValidation';
import { CurrencySymbol } from '../../Utility/Constants';

class OutsourceMapping extends Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            rowsPerPage: 10,
            selectOutLabName: null,
            selectOutLabName1: '',
            outsourceTestPrice: '',
            outsourceMappingData: [],
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            testNameTableValue: [],
            testNameGet: [],
            testOutSourceLabGet: [],
            deletedID: [],
            deletedPopup: false,
            deletedapiID: '',
            searchKey: '',
            selectedIndex: '',
            SearchText: "",
            disableBtn: false,
            isLoader: false,
            selectedEditID: null,
            // State for hierarchical structure
            selectedHeadService: null,
            selectedServiceName: null,
            serviceDetails: []
        }
    }

    componentDidMount() {
        this.getTestNameData()
        this.getOutSourceLabData()
        this.getOutsourceMappingData()
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
        })
    }

    getTestNameData = () => {
        try {
            // Pass module_type as parameter for HISTOPATHOLOGY
            RestAPIService.getAll(`${Serviceurls.MODULE_LIST}?module_type=HISTOPATHOLOGY`)
                .then(response => {
                    if (response.data.status === "success") {
                        const moduleData = response.data.data || {};
                        
                        // Extract service heads from HISTOPATHOLOGY module
                        const histopathologyData = moduleData.HISTOPATHOLOGY || [];
                        
                        this.setState({
                            testNameGet: histopathologyData
                        })
                    }
                }).catch(e => {
                    this.setState({
                        isErrorMsg: true,
                        isErrorMsgText: e.message
                    })
                })

        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.message
            })
        }
    }

    getOutSourceLabData = () => {
        try {
            RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_OUTSOURCE_CONFIG)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            testOutSourceLabGet: response.data.data ? response.data.data : []
                        })
                    }
                }).catch(e => {
                    this.setState({
                        isErrorMsg: true,
                        isErrorMsgText: e.message
                    })
                })

        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.message
            })
        }
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    getOutsourceMappingData = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_OUTSOURCE_MAPPING + "?search_key=" + this.state.searchKey)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            outsourceMappingData: response.data.data ? response.data.data : []
                        }, () => { this.LoaderFunction(false) })
                    }
                }).catch(e => {
                    this.LoaderFunction(false)
                    this.setState({
                        isErrorMsg: true,
                        isErrorMsgText: e.message
                    })
                })

        } catch (e) {
            this.LoaderFunction(false)
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.message
            })
        }
    }

    postOutsourceMappingData = () => {
        try {
            this.LoaderFunction(true)
            var states = this.state
            var outsourceLabID = states.selectOutLabName ? states.selectOutLabName.id : null
            var outsourceLabName = states.selectOutLabName ? states.selectOutLabName.outsource_laboratory_name : null
            
            // Prepare outsource_line_item according to API structure
            const outsourceLineItem = states.testNameTableValue.map(item => ({
                id: item.id || null,
                service_head_id: item.service_head_id || null,
                service_head_str: item.service_head_str || null,
                service_name_id: item.service_name_id || null,
                service_name_str: item.service_name_str || null,
                amount: item.amount || null
            }))

            var data = {
                "outsource_id": outsourceLabID,
                "outsource_laboratory_name": outsourceLabName,
                "outsource_line_item": outsourceLineItem
            }

            if (this.state.selectedEditID) {
                data['outsource_id'] = this.state.selectedEditID
                data['deleted_ids'] = this.state.deletedID
            }

            this.setState({ disableBtn: true })
            RestAPIService.create(data, Serviceurls.HISTOPATHOLOGY_OUTSOURCE_MAPPING)
                .then(response => {
                    if (response.data.status == "success") {
                        this.setState({
                            successMsg: true,
                            successMsgText: response.data.message
                        }, () => {
                            this.LoaderFunction(false)
                            this.getOutsourceMappingData()
                            this.setState({
                                selectOutLabName1: '',
                                testNameTableValue: [],
                                selectedEditID: '',
                                disableBtn: false,
                                selectedHeadService: null,
                                selectedServiceName: null,
                                serviceDetails: [],
                                outsourceTestPrice: ''
                            })
                        })
                    }
                }).catch(e => {
                    this.LoaderFunction(false)
                    this.setState({
                        isErrorMsg: true,
                        isErrorMsgText: e.response?.data?.message || e.message,
                        disableBtn: false,
                    })
                })
        } catch (e) {
            this.LoaderFunction(false)
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.message,
                disableBtn: false,
            })
        }
    }

    editOutsourceMappingData = (item, index) => {
        this.setState({
            selectedEditID: item.out_source_id,
            selectOutLabName1: item.out_source__outsource_laboratory_name ? item.out_source__outsource_laboratory_name : '',
            testNameTableValue: item.data,
            selectedIndex: index,
            // deletedID: []
        })
    }

    deleteOutsourceMappingData = (ID) => {
        try {
            var data = {
                "outsource_id": ID
            }
            RestAPIService.delete(Serviceurls.HISTOPATHOLOGY_OUTSOURCE_MAPPING, data)
                .then(response => {
                    if (response.data.status == "success") {
                        this.setState({
                            successMsg: true,
                            successMsgText: response.data.message
                        }, () => {
                            this.getOutsourceMappingData()
                        })
                    }
                }).catch((e => {
                    this.setState({
                        isErrorMsg: true,
                        isErrorMsgText: e.response?.data?.message || e.message
                    })
                }))

        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.message
            })
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: +event.target.value, page: 0 });
    }

    numInputcheck = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        
        // Validation for numbers only with max 6 digits
        if (value === "" || (CommonValidation.NumberWithDot(value) && value >= 0 && value.length <= 6)) {
            this.setState({
                [name]: value,
            });
        }
    };

    renderTextBox = (label, width, value, name) => {
        return (
            <div>
                <TextField
                    size={'small'}
                    sx={{ width: width }}
                    label={label}
                    rows={3}
                    name={name}
                    value={value}
                    variant="outlined"
                    onChange={this.numInputcheck}
                    inputProps={{
                        maxLength: 6 // Max 6 digits
                    }}
                />
            </div>
        )
    }

    renderLeftTable = () => {
        var states = this.state
        const { t } = this.props
        const filtereddata = this.state.outsourceMappingData.filter((data) => {
            return (
                (data.out_source__outsource_laboratory_name === null ? null : data.out_source__outsource_laboratory_name.toLowerCase().includes(this.state.SearchText.toLowerCase())) ||
                (data.data === null ? null : JSON.stringify(data.data).toLowerCase().includes(this.state.SearchText.toLowerCase()))
            );
        });
        return (
            <div>
                <Paper elevation={0}>
                    <Box className="eMed_Search_Box_">
                        <TextField
                            variant='standard'
                            placeholder='Search'
                            value={this.state.SearchText}
                            onChange={(e) => { this.setState({ SearchText: e.target.value }) }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{ width: '15vw' }} />
                    </Box>
                    <TableContainer className='eMed_ConfigTable_Paper'>
                        <Table stickyHeader size='small'>
                            <TableHead sx={{ height: '7.3vh' }}>
                                <TableRow>
                                    <TableCell id='eMed_config_TableRow1' align='left' sx={{ color: Colors.HeadText }} >{t('SNo')}</TableCell>
                                    <TableCell id='eMed_config_TableRow' align='left' sx={{ color: Colors.HeadText }}>{t("LaboratoryName")}</TableCell>
                                    <TableCell id='eMed_config_TableRow' align='left' sx={{ color: Colors.HeadText }}>{t('Service Head')}</TableCell>
                                    <TableCell id='eMed_config_TableRow' align='left' sx={{ color: Colors.HeadText }}>{t('Service Name')}</TableCell>
                                    <TableCell id='eMed_config_TableRow' align='center' sx={{ color: Colors.HeadText }}>{t('Action')}</TableCell>
                                </TableRow>
                            </TableHead>
                            {filtereddata.slice(states.page * states.rowsPerPage, states.page * states.rowsPerPage + states.rowsPerPage)
                                .map((data, index) => {
                                    var sno = (states.page * states.rowsPerPage) + (index + 1)
                                    return (
                                        <TableBody key={index}>
                                            <TableRow sx={{ bgcolor: this.state.selectedEditID && this.state.selectedIndex == index ? '#e2e2e2' : 'white' }}>
                                                <TableCell align='left'><div>{sno}</div></TableCell>
                                                <TableCell align='left'>
                                                    {data.out_source__outsource_laboratory_name && data.out_source__outsource_laboratory_name.length > 15 ?
                                                        <Tooltip placement="top" title={data.out_source__outsource_laboratory_name} arrow>
                                                            <div >{data.out_source__outsource_laboratory_name ? data.out_source__outsource_laboratory_name.slice(0, 15) + '...' : '-'}</div>
                                                        </Tooltip> : <div> {data.out_source__outsource_laboratory_name ? data.out_source__outsource_laboratory_name : '-'}</div>}</TableCell>
                                                <TableCell align='left'>
                                                    {data.data && data.data.map((item, idx) => (
                                                        <div key={idx}>
                                                            {item.service_head_str || '-'}
                                                        </div>
                                                    ))}
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {data.data && data.data.map((item, idx) => (
                                                        <div key={idx}>
                                                            {item.service_name_str || '-'}
                                                        </div>
                                                    ))}
                                                </TableCell>
                                                <TableCell align='center'>
                                                    <div className='eMed_TestConfig_Con'>
                                                        <IconButton size='small' disabled={!CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess}>
                                                            <img src={CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess ? ImagePaths.Edit?.default || ImagePaths.Edit : ImagePaths.DisabledEdit?.default || ImagePaths.DisabledEdit} className='eMed_TestConfig_DeleteIcon' alt='Edit'
                                                                onClick={() => { this.editOutsourceMappingData(data, index) }}
                                                            />
                                                        </IconButton>
                                                        <IconButton size='small' disabled={!CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess || (this.state.selectedEditID && this.state.selectedEditID === data.out_source_id)}>
                                                            <img src={CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess && !(this.state.selectedEditID && this.state.selectedEditID === data.out_source_id) ? ImagePaths.Delete?.default || ImagePaths.Delete : ImagePaths.DisabledDelete?.default || ImagePaths.DisabledDelete} className='eMed_TestConfig_DeleteIcon' alt='Delete'
                                                                onClick={() => {
                                                                    this.setState({
                                                                        deletedPopup: true,
                                                                        deletedapiID: data.out_source_id
                                                                    })
                                                                }}
                                                            />
                                                        </IconButton>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                })
                            }
                        </Table>
                        {filtereddata.length === 0 ?
                            <div className='eMed_TestConfig_NoRecords'>
                                {t('NoRecordsShown')}
                            </div> : null}
                    </TableContainer>
                </Paper>
                <div className='eMed_TestConfig_LeftPageination'>
                    <TablePagination
                        component='div'
                        id="eMed_tbl_pagination"
                        rowsPerPageOptions={[10, 20, 30]}
                        count={filtereddata.length}
                        rowsPerPage={states.rowsPerPage}
                        page={states.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </div>
            </div>
        )
    }

    // renderRightTable = () => {
    //     var { testNameTableValue } = this.state
    //     const { t } = this.props
    //     return (
    //         <div>
    //             <Paper elevation={0}>
    //                 <TableContainer className='eMed_ConfigRightTable_Paper'>
    //                     <Table stickyHeader size='small'>
    //                         <TableHead sx={{ flex: 1, }}>
    //                             <TableRow>
    //                                 <TableCell id='eMed_config_TableRow1' align='left'>{t('SNo')}</TableCell>
    //                                 <TableCell id='eMed_config_TableRow' align='left'>{t('Service Head')}</TableCell>
    //                                 <TableCell id='eMed_config_TableRow' align='left'>{t('Service Name')}</TableCell>
    //                                 <TableCell id='eMed_config_TableRow' align='left'>{t('Price') + ` (${CurrencySymbol})`}</TableCell>
    //                                 <TableCell id='eMed_config_TableRow' align='center'>{t('Action')}</TableCell>
    //                             </TableRow>
    //                         </TableHead>
    //                         {testNameTableValue && testNameTableValue.length > 0 ? testNameTableValue.map((item, index) => {
    //                             return (
    //                                 <TableBody key={index}>
    //                                     <TableRow>
    //                                         <TableCell align='left'><div>{index + 1}</div></TableCell>
    //                                         <TableCell align='left'>{item.service_head_str || '-'}</TableCell>
    //                                         <TableCell align='left'>{item.service_name_str || '-'}</TableCell>
    //                                         <TableCell align='left'>{item.amount ? AmountFormat(item.amount)?.replace(`${CurrencySymbol}`, "") : '0.00'}</TableCell>
    //                                         <TableCell align='center'>
    //                                             <Tooltip title='Delete' placement='top' arrow>
    //                                                 <img className='eMed_TestConfig_DeleteIcon' style={{ cursor: 'pointer' }} src={ImagePaths.Delete?.default || ImagePaths.Delete} alt="Delete"
    //                                                     onClick={() => {
    //                                                         var deletedID = []
    //                                                         if (item.id) {
    //                                                             deletedID.push(item.id)
    //                                                         }
    //                                                         testNameTableValue.splice(index, 1)
    //                                                         this.setState({
    //                                                             testNameTableValue,
    //                                                             deletedID: deletedID
    //                                                         })
    //                                                     }}
    //                                                 />
    //                                             </Tooltip>
    //                                         </TableCell>
    //                                     </TableRow>
    //                                 </TableBody>
    //                             )
    //                         }) : null}
    //                     </Table>
    //                     {testNameTableValue.length === 0 ?
    //                         <div className='eMed_TestConfig_NoRecords'>
    //                             {t("NoRecordsFound")}
    //                         </div> : null}
    //                 </TableContainer>
    //             </Paper>
    //         </div>
    //     )
    // }
//     renderRightTable = () => {
//     var { testNameTableValue } = this.state
//     const { t } = this.props
//     return (
//         <div>
//             <Paper elevation={0}>
//                 <TableContainer className='eMed_ConfigRightTable_Paper'>
//                     <Table stickyHeader size='small'>
//                         <TableHead sx={{ flex: 1, }}>
//                             <TableRow>
//                                 <TableCell id='eMed_config_TableRow1' align='left'>{t('SNo')}</TableCell>
//                                 <TableCell id='eMed_config_TableRow' align='left'>{t('Service Head')}</TableCell>
//                                 <TableCell id='eMed_config_TableRow' align='left'>{t('Service Name')}</TableCell>
//                                 <TableCell id='eMed_config_TableRow' align='left'>{t('Price') + ` (${CurrencySymbol})`}</TableCell>
//                                 <TableCell id='eMed_config_TableRow' align='center'>{t('Action')}</TableCell>
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {testNameTableValue && testNameTableValue.length > 0 ? testNameTableValue.map((item, index) => {
//                                 return (
//                                     <TableRow key={index}>
//                                         <TableCell align='left'><div>{index + 1}</div></TableCell>
//                                         <TableCell align='left'>{item.service_head_str || '-'}</TableCell>
//                                         <TableCell align='left'>{item.service_name_str || '-'}</TableCell>
//                                         <TableCell align='left'>{item.amount ? AmountFormat(item.amount)?.replace(`${CurrencySymbol}`, "") : '0.00'}</TableCell>
//                                         <TableCell align='center'>
//                                             <Tooltip title='Delete' placement='top' arrow>
//                                                 <img className='eMed_TestConfig_DeleteIcon' style={{ cursor: 'pointer' }} src={ImagePaths.Delete?.default || ImagePaths.Delete} alt="Delete"
//                                                     onClick={() => {
//                                                         var deletedID = []
//                                                         if (item.id) {
//                                                             deletedID.push(item.id)
//                                                         }
//                                                         testNameTableValue.splice(index, 1)
//                                                         this.setState({
//                                                             // testNameTableValue,
//                                                             deletedID: deletedID
//                                                         })
//                                                     }}
//                                                 />
//                                             </Tooltip>
//                                         </TableCell>
//                                     </TableRow>
//                                 )
//                             }) : null}
//                         </TableBody>
//                         {testNameTableValue.length === 0 ?
//                             <TableBody>
//                                 <TableRow>
//                                     <TableCell colSpan={5} align="center">
//                                         <div className='eMed_TestConfig_NoRecords'>
//                                             {t("NoRecordsFound")}
//                                         </div>
//                                     </TableCell>
//                                 </TableRow>
//                             </TableBody>
//                         : null}
//                     </Table>
//                 </TableContainer>
//             </Paper>
//         </div>
//     )
// } by var

renderRightTable = () => {
    var { testNameTableValue } = this.state
    const { t } = this.props
    return (
        <div>
            <Paper elevation={0}>
                <TableContainer className='eMed_ConfigRightTable_Paper'>
                    <Table stickyHeader size='small'>
                        <TableHead sx={{ flex: 1, }}>
                            <TableRow>
                                <TableCell id='eMed_config_TableRow1' align='left'>{t('SNo')}</TableCell>
                                <TableCell id='eMed_config_TableRow' align='left'>{t('Service Head')}</TableCell>
                                <TableCell id='eMed_config_TableRow' align='left'>{t('Service Name')}</TableCell>
                                <TableCell id='eMed_config_TableRow' align='left'>{t('Price') + ` (${CurrencySymbol})`}</TableCell>
                                <TableCell id='eMed_config_TableRow' align='center'>{t('Action')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {testNameTableValue && testNameTableValue.length > 0 ? testNameTableValue.map((item, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell align='left'><div>{index + 1}</div></TableCell>
                                        <TableCell align='left'>{item.service_head_str || '-'}</TableCell>
                                        <TableCell align='left'>{item.service_name_str || '-'}</TableCell>
                                        <TableCell align='left'>{item.amount ? AmountFormat(item.amount)?.replace(`${CurrencySymbol}`, "") : '0.00'}</TableCell>
                                        <TableCell align='center'>
                                            <Tooltip title='Delete' placement='top' arrow>
                                                <img className='eMed_TestConfig_DeleteIcon' style={{ cursor: 'pointer' }} src={ImagePaths.Delete?.default || ImagePaths.Delete} alt="Delete"
                                                    onClick={() => {
                                                        // Create a new array without the item to be deleted
                                                        const updatedTableValue = testNameTableValue.filter((_, i) => i !== index);
                                                        
                                                        // If the item has an ID (from edit mode), add it to deletedID array
                                                        var deletedID = [...this.state.deletedID];
                                                        if (item.id) {
                                                            deletedID.push(item.id);
                                                        }
                                                        
                                                        this.setState({
                                                            testNameTableValue: updatedTableValue,
                                                            deletedID: deletedID
                                                        })
                                                    }}
                                                />
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                )
                            }) : null}
                        </TableBody>
                        {testNameTableValue.length === 0 ?
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        <div className='eMed_TestConfig_NoRecords'>
                                            {t("NoRecordsFound")}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        : null}
                    </Table>
                </TableContainer>
            </Paper>
        </div>
    )
}

    clearValue = () => {
        this.setState({
            selectOutLabName1: null,
            outsourceTestPrice: '',
            testNameTableValue: [],
            selectedIndex: '',
            selectedEditID: '',
            selectedHeadService: null,
            selectedServiceName: null,
            serviceDetails: []
        })
    }

    validCheck = () => {
        const { t } = this.props
        var saveErrorMsg = ''
        var states = this.state
        if (!states.selectOutLabName1) {
            saveErrorMsg = t('AddOutSourceLab')
        } else if ((states.testNameTableValue).length == 0) {
            saveErrorMsg = t('AddTest')
        }
        return saveErrorMsg
    }

    onSave = () => {
        var inValid = this.validCheck()
        if (inValid) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: inValid
            })
        } else {
            this.postOutsourceMappingData()
        }
    }

    // Check if Service Head is already added as "full" (without Service Name)
    // isServiceHeadAddedAsFull = (serviceHeadId) => {
    //     return this.state.testNameTableValue.some(item => 
    //         item.service_head_id === serviceHeadId && !item.service_name_id
    //     );
    // }

    // Check if specific Service Name is already added under any Service Head
    isServiceNameAlreadyAdded = (serviceNameId) => {
        return this.state.testNameTableValue.some(item => 
            item.service_name_id === serviceNameId
        );
    }

    // Check if specific Service Head + Service Name combination is already added
    isServiceHeadWithNameAlreadyAdded = (serviceHeadId, serviceNameId) => {
        return this.state.testNameTableValue.some(item => 
            item.service_head_id === serviceHeadId && item.service_name_id === serviceNameId
        );
    }

    // Check if any Service Name from this Service Head is already added
    isAnyServiceNameFromHeadAdded = (serviceHeadId) => {
        return this.state.testNameTableValue.some(item => 
            item.service_head_id === serviceHeadId && item.service_name_id
        );
    }

    addTestName = () => {
    var states = this.state
    const { t } = this.props
    
    // Validation checks for mandatory fields - BOTH are required
    if (!states.selectedHeadService) {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: t('ServiceHeadIsMandatory')
        })
        return
    }

    if (!states.selectedServiceName) {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: t('ServiceNameIsMandatory')
        })
        return
    }

    // Validation for Outsource Amount (numbers only, max 6 digits)
    if (!states.outsourceTestPrice || states.outsourceTestPrice === '' || states.outsourceTestPrice === '0') {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: t('EnterValidOutsourceAmt')
        })
        return
    }

    if (!CommonValidation.NumberWithDot(states.outsourceTestPrice) || states.outsourceTestPrice.length > 6) {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: t('EnterValid6DigitAmount')
        })
        return
    }

    // Check if this specific service name is already added
    if (this.isServiceNameAlreadyAdded(states.selectedServiceName.id)) {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: t('ThisServiceIsAlreadyAdded')
        })
        return
    }

    // Prepare data for specific service
    const newItem = {
        service_head_id: states.selectedHeadService.id,
        service_head_str: states.selectedHeadService.head_name,
        service_name_id: states.selectedServiceName.id,
        service_name_str: states.selectedServiceName.service_name || states.selectedServiceName.name || states.selectedServiceName.test_name,
        amount: states.outsourceTestPrice
    }

    // Debug: Log the new item being added
    console.log('Adding new item:', newItem);

    // Add to table
    const updatedTableValue = [...states.testNameTableValue, newItem];
    
    this.setState({
        testNameTableValue: updatedTableValue,
        selectedServiceName: null,
        selectedHeadService: null,
        serviceDetails: [],
        outsourceTestPrice: ''
    })
}

    PopupClose = () => {
        this.setState({
            deletedPopup: false
        })
    }

    removeDataList = () => {
        this.deleteOutsourceMappingData(this.state.deletedapiID)
        this.setState({
            deletedPopup: false
        })
    }

    render() {
        const { t } = this.props
        var states = this.state

        // Filter available Service Heads
        const availableServiceHeads = states.testNameGet.filter(serviceHead => {
            // If Service Head is added as "full", hide it
            if ((!serviceHead.id)) {
                return false;
            }
            return true;
        });

        // Filter available Service Names based on selected Service Head
        const availableServiceNames = states.serviceDetails.filter(serviceName => {
            // // If Service Head is added as "full", hide all its Service Names
            // if (states.selectedHeadService && this.isServiceHeadAddedAsFull(states.selectedHeadService.id)) {
            //     return false;
            // }
            // If this specific Service Name is already added under this Service Head, hide it
            if (states.selectedHeadService && this.isServiceHeadWithNameAlreadyAdded(states.selectedHeadService.id, serviceName.id)) {
                return false;
            }
            return true;
        });

        return (
            <div className='eMed_TestConfig_MainContainer'>
                <div className='eMed_TestConfig_Con'>
                    <div className='eMed_TestConfig_leftSide'>
                        {this.renderLeftTable()}
                    </div>
                    <div className='eMed_TestConfig_RightSide'>
                        <div className='eMed_TestConfig_RightHead'>
                            <p className='eMed_Testconfig_RightHead_text'>{t('OutsourceMapping')}</p>
                        </div>
                        <div className='eMed_TestConfig_RightContentBox'>
                            {/* Outsource Laboratory Name */}
                            <div className='eMed_TestConfig_RightMethod'>
                                <Autocomplete
                                    disabled={this.state.selectedEditID && this.state.selectedEditID ? true : false}
                                    options={states.testOutSourceLabGet || []}
                                    getOptionLabel={(options) => typeof (options) === "string" ? options : options.outsource_laboratory_name || ''}
                                    onChange={(e, value) => {
                                        this.setState({
                                            selectOutLabName1: value,
                                            selectOutLabName: value,
                                        })
                                    }}
                                    value={states.selectOutLabName1 ? states.selectOutLabName1 : null}
                                    id="combo-box-demo"
                                    sx={{ width: "29vw" }}
                                    renderInput={(params) => <TextField {...params} label={t("OutsourceLaboratoryName") + "*"} size='small' />}
                                />
                            </div>
                            
                            {/* Service Head and Service Name - Hierarchical Structure */}
                            <div className='eMed_TestConfig_RightMethod'>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: '1vw' }}>
                                    {/* Service Head */}
                                    <Autocomplete
                                        clearIcon
                                        size='small'
                                        sx={{ width: "14vw" }}
                                        options={states.testNameGet}
                                        getOptionLabel={(option) => option?.head_name || ''}
                                        value={states.selectedHeadService || null}
                                        onChange={(e, value) => {
                                            this.setState({
                                                selectedHeadService: value,
                                                selectedServiceName: null,
                                                serviceDetails: value?.service_details || []
                                            })
                                        }}
                                        renderInput={(params) => <TextField {...params} label={t("Service Head")} size='small' />}
                                    />
                                    
                                    {/* Service Name */}
                                    <Autocomplete
                                        clearIcon
                                        size='small'
                                        sx={{ width: "14vw" }}
                                        options={availableServiceNames}
                                        getOptionLabel={(option) => option?.service_name || option?.name || ''}
                                        value={states.selectedServiceName}
                                        onChange={(e, value) => {
                                            this.setState({
                                                selectedServiceName: value
                                            })
                                        }}
                                        renderInput={(params) => <TextField {...params} label={t("Service Name")} size='small' />}
                                    />
                                </Box>
                            </div>

                            {/* Outsource Amount and Add Button */}
                            <div className='eMed_TestConfig_RightMethod'>
                                {this.renderTextBox(t("OutsourceAmount") , '14vw', states.outsourceTestPrice, 'outsourceTestPrice')}
                                <Button id='eMed_Btn_Text' variant='contained' sx={{ width: '5vw' }}
                                    onClick={() => { this.addTestName() }}
                                >{t('Add')}</Button>
                            </div>
                            
                            {/* Right Side Table */}
                            <div className='eMed_TestConfig_Right_SideTable'>
                                {this.renderRightTable()}
                            </div>
                        </div>
                        <div className='eMed_TestConfig_RightBtnCon'>
                            <Stack spacing={2} direction="row">
                                <Button id='eMed_Btn_Text' variant='outlined' onClick={() => { this.clearValue() }}>{t("Clear")}</Button>
                                <Button id='eMed_Btn_Text' emed_tid='OutsourceMap_Save_Btn' disabled={this.state.disableBtn ? true : !CheckAccessFunc("Laboratory", "Configuration", "Outsource Mapping", null, "Tab")?.editAccess} variant='contained' onClick={() => { this.onSave() }}>{t("Save")}</Button>
                            </Stack>
                        </div>
                    </div>
                </div>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.deletedPopup ?
                    <DeletePopup DeletTitle={t("ConfirmremoveOutsourceMap")}
                        DeleteNotify={t("effectEntireConfig")}
                        DeletContent={t("linkedOutsourceMap")}
                        deleteAlertPopupClose={this.PopupClose.bind(this)}
                        removeData={this.removeDataList.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader} />
            </div>
        );
    }
}

export default withTranslation()(OutsourceMapping);